module.exports = __webpack_public_path__ + "static/img/Graphic-ATF.27c94890.png";